module["exports"] = [
  "Снаб",
  "Торг",
  "Пром",
  "Трейд",
  "Сбыт"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/company/suffix.js
// module id = 1666
// module chunks = 1